/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Window_EndInputs */

const vi_irrigation_schedule_window_end = /** @type {(inputs: Irrigation_Schedule_Window_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến`)
};

/**

* @param {Irrigation_Schedule_Window_EndInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_window_end = /** @type {((inputs?: Irrigation_Schedule_Window_EndInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Window_EndInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_window_end(inputs)
});